import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ConversationContainer from '../containers/conversation_container';
import BrowserUtils from '../utils/browser';

const ConversationList = ({
  conversations,
  selectLoad,
  hasConversations,
  hasActiveConversation,
  newConversation,
  hasNextPage,
  newConversationLabels,
  newConversationIds,
  fetchNewPage
}) => {

  useEffect(() => {
    if (needsConversationLoad()) {
      selectLoad(conversations[0].node);
    }
  }, []);

  const needsConversationLoad = () => {
    return (
      BrowserUtils.isDesktop() &&
        hasConversations &&
        !hasActiveConversation &&
        !newConversation
    );
  }

  const rows = conversations.filter(conversation => {
    return conversation.node.participants.length > 0;
  }).map(conversation => {
    return <ConversationContainer key={conversation.node.id} conversation={conversation.node} />;
  });

  if (newConversationLabels && newConversationLabels.length) {
    rows.unshift(
      <div key="new" className="conversation start-conversation">
        <a href={`/conversations/new?participant_id=${newConversationIds.join(',')}`} className="nostyle">
          <p className="t5 w3">{newConversationLabels.join(', ')}</p>
          <p className="t5">Start this conversation</p>
        </a>
      </div>
    );
  }

  return (
    <section className="conversations-list">
      {
        newConversationIds && newConversationIds.length
          ? null
          : <div className="row gutters-sm-down"><span className="t3 w2-5">{hasConversations ? 'Recent' : 'No conversations yet'}</span></div>
      }
      <div className="row conversations pb-60">
        {rows}
        {
          hasNextPage
            ? <button className="btn-main more" onClick={fetchNewPage}>More</button>
            : null
        }
      </div>
    </section>
  );
}

ConversationList.propTypes = {
  conversations: PropTypes.array.isRequired,
  hasNextPage: PropTypes.bool.isRequired,
  hasActiveConversation: PropTypes.bool.isRequired,
  newConversation: PropTypes.bool.isRequired,
  hasConversations: PropTypes.bool.isRequired,
  selectLoad: PropTypes.func.isRequired,
  fetchNewPage: PropTypes.func.isRequired
};

export default ConversationList;
